// AddLandPropertyPageSkeleton.jsx
import PageHeader from "../../../../components/admin/common/form-elements/PageHeader";

const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse bg-gray-200 rounded-md ${className}`} />
);

const AddLandPropertyPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background font-poppins">
      {/* Header (Static) */}
      <PageHeader title="Loading Property..." />

      <div className="max-full mx-auto px-3 sm:px-4 md:px-6 py-3 sm:py-4 md:py-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-4">
          {/* LEFT COLUMN */}
          <div className="space-y-6">
            {/* Property Name */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-3">
              <Skeleton className="h-4 w-36" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Video Upload */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-4">
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-[160px] w-full" />
            </div>

            {/* Image Upload */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-4">
              <Skeleton className="h-4 w-44" />
              <Skeleton className="h-[220px] w-full" />
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="space-y-6">
            {/* Pre-Leased */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-4">
              <Skeleton className="h-4 w-52" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Floor Allowed */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-4">
              <Skeleton className="h-4 w-56" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Floor Allowed Details */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-6">
              <Skeleton className="h-4 w-60" />

              <Skeleton className="h-10 w-full" />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
              </div>
            </div>

            {/* Location */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 space-y-4">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-10 w-full" />
            </div>

            {/* Submit Button */}
            <Skeleton className="h-12 w-full rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLandPropertyPageSkeleton;
